var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1261,
    height: 795,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#979797",
    strokeWidth: 5,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.3,
    strokeDasharray: "1,10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M701.274 475.877C685.573 519.541 792.188 797.758 337.236 792 290.299 791.406 49.146 773.456 10 618.607c-39.145-154.85 93.539-187.732 108.387-311.687 12.175-101.635 104.945-310.377 549.946-304 445.002 6.377 620.794 151.484 488.189 281.08-159.557 155.936 10.194 162.033-56.522 321.333-20.288 48.442-17.446 104.693-13.188 110.864M1229.276 43.615l22.109-6.34 6.34 22.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.67 71.271c73.687 28.917 128.35 22.246 163.99-20.013M687 421.09l15.09 17.358 17.358-15.09M687 441.09l15.09 17.358 17.358-15.09"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.86370eecf2bf2b7674afe8335e249429.svg";
export { ForwardRef as ReactComponent };